export const staticPermissionEmployeeRole={
    'employee':{
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "hrms_users"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            // {
            //     "uuid": "074e8fe3-a7ab-4e53-beaa-66966be75170",
            //     "parent_id": "51962a8b-7364-4f0d-a7cc-fc7088769006",
            //     "name": "Self Tax Management",
            //     "slug": "self-tax-management",
            //     "module_url": "/tax-management/manage-tax",
            //     "icon": "ReceiptLong",
            //     "module_order": "1",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-tax_house_rent_detail",
            //         "view-self_tax_management_tax_slip",
            //         "view-self_tax_management_previous_employee",
            //         "view-self_tax_management_tax_computation",
            //         "view-self_tax_management_other_income",
            //         "view-self_tax_management_house_rental",
            //         "view-self_tax_management_exemptions",
            //         "view-self_tax_management_deductions",
            //         "view-self_tax_management_summary",
            //         "update-tax_house_rent_detail",
            //         "update-tax_house_rent_status",
            //         "view-tax_house_rent_file",
            //         "view-tax_slip",
            //         "download-tax_slip",
            //         "upload-tax_declare_submission_proof",
            //         "update-tax_declare_amount"
            //     ]
            // },
            // {
            //     "uuid": "108ad19e-b60a-4512-92e7-d0a1ff8f637f",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Candidates",
            //     "slug": "candidates",
            //     "module_url": "/recruitment/candidates",
            //     "icon": "People",
            //     "module_order": "3",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-candidate_list"
            //     ]
            // },
            // {
            //     "uuid": "18b88f01-081f-4233-9887-983f2910047d",
            //     "parent_id": "20cae16b-71dc-4592-bd3c-f524c01bac1f",
            //     "name": "Ticket - details",
            //     "slug": "ticket---details",
            //     "module_url": "/tickets/tickets-list/details",
            //     "icon": "Leaderboard",
            //     "module_order": "1",
            //     "is_navigation": 0,
            //     "operations": [
            //         "update-ticket_status",
            //         "update-ticket_priority",
            //         "create-ticket_notes_todo",
            //         "create-ticket_update_notes_todo_status",
            //         "create-ticket_attach_document",
            //         "create-ticket_comment",
            //         "view-ticket_details"
            //     ]
            // },
            // {
            //     "uuid": "1b6f6df8-3ca0-411b-9160-bc75d2229e04",
            //     "parent_id": "c4a8e192-b898-42b7-afa6-3d60df2a237f",
            //     "name": "My Pay",
            //     "slug": "my-pay",
            //     "module_url": "/compensation/mypay",
            //     "icon": "Paid",
            //     "module_order": "1",
            //     "is_navigation": 1,
            //     "operations": [
            //         "create-claim",
            //         "delete-claim",
            //         "view-claim_summary",
            //         "view-claim_details",
            //         "view-claim_monthly_summary"
            //     ]
            // },
            // {
            //     "uuid": "20cae16b-71dc-4592-bd3c-f524c01bac1f",
            //     "parent_id": "0",
            //     "name": "Ticket",
            //     "slug": "ticket",
            //     "module_url": " ",
            //     "icon": "SupportAgent",
            //     "module_order": "8",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "311de242-5032-4f98-bebd-89c339442de0",
            //     "parent_id": "0",
            //     "name": "People",
            //     "slug": "people",
            //     "module_url": "/employee-people",
            //     "icon": "People",
            //     "module_order": "10",
            //     "is_navigation": 1,
            //     "operations": [
            //         "tab-organization_chart"
            //     ]
            // },
            // {
            //     "uuid": "4f697ad8-be9f-428c-8621-2c7b75200c59",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Interviews",
            //     "slug": "interviews",
            //     "module_url": "/recruitment/interviews",
            //     "icon": "CalendarMonth",
            //     "module_order": "4",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-interviews_list",
            //         "view-candidate_rejected_list",
            //         "view-interview_completed_list",
            //         "view-interview_scheduled_list",
            //         "view-cvrejected_list",
            //         "view-cvshortlisted_list",
            //         "view-screening_list",
            //         "view-newcandidate_list",
            //         "update-candidate_stage"
            //     ]
            // },
            // {
            //     "uuid": "50c2bf0c-7968-4e3f-9408-b95e34f1b848",
            //     "parent_id": "0",
            //     "name": "Policy",
            //     "slug": "policy",
            //     "module_url": "/company-policy",
            //     "icon": "Policy",
            //     "module_order": "9",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-company_policy"
            //     ]
            // },
            // {
            //     "uuid": "51962a8b-7364-4f0d-a7cc-fc7088769006",
            //     "parent_id": "0",
            //     "name": "Tax Management",
            //     "slug": "tax-management",
            //     "module_url": "/tax-management",
            //     "icon": "ReceiptLong",
            //     "module_order": "5",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "5cb04c36-6b11-470f-8344-beed355a8a4b",
            //     "parent_id": "0",
            //     "name": "Settings",
            //     "slug": "settings",
            //     "module_url": " ",
            //     "icon": "Settings",
            //     "module_order": "1",
            //     "is_navigation": 0,
            //     "operations": []
            // },
            // {
            //     "uuid": "5e831f8c-19b7-49c4-8ea5-288316852392",
            //     "parent_id": "0",
            //     "name": "Attendance",
            //     "slug": "attendance",
            //     "module_url": "/attendance",
            //     "icon": "EventAvailable",
            //     "module_order": "2",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "5eb01018-fe3f-48a8-82d8-f0775feba1c2",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Candidate Details",
            //     "slug": "candidate-details",
            //     "module_url": "/recruitment/candidates/details",
            //     "icon": " ",
            //     "module_order": "",
            //     "is_navigation": 0,
            //     "operations": [
            //         "view-candidate_details",
            //         "view-candidate_summary",
            //         "view-recommendation_list",
            //         "view-candidate_logs_details",
            //         "view-resume_fetch",
            //         "update-candidate_stage"
            //     ]
            // },
            // {
            //     "uuid": "691afe5c-aea1-440f-b359-27a1d73cf96e",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Jobs Details",
            //     "slug": "jobs-details",
            //     "module_url": "/recruitment/jobs/details",
            //     "icon": " ",
            //     "module_order": "",
            //     "is_navigation": 0,
            //     "operations": [
            //         "view-job_details",
            //         "view-job_summary",
            //         "view-candidate_track_count"
            //     ]
            // },
            // {
            //     "uuid": "6eac0620-9604-4334-846f-4d7b76928810",
            //     "parent_id": "0",
            //     "name": "My Team Zone",
            //     "slug": "my-team-zone",
            //     "module_url": "/myteamzone",
            //     "icon": "Groups",
            //     "module_order": "7",
            //     "is_navigation": 1,
            //     "operations": [
            //         "tab-attendance_regularize_request",
            //         "tab-pip",
            //         "tab-probation_confirmation_request",
            //         "tab-exit_request",
            //         "tab-exit_request_overview",
            //         "tab-attendance_summary",
            //         "tab-attendance_livetracker",
            //         "tab-leave_report",
            //         "tab-leave_leave_request",
            //         "tab-leave_employee_details",
            //         "tab-leave",
            //         "tab-leave_summary",
            //         "tab-attendance_report",
            //         "action-myteam_exit_requests",
            //         "tab-attendance",
            //         "tab-overview",
            //         "view-exit_request_approver_review",
            //         "export-myteam_attendance_report",
            //         "export-myteam_leave_report",
            //         "view-myteam_pip_details",
            //         "create-myteam_pip",
            //         "update-myteam_regularization_requests_status",
            //         "view-myteam_leave_requests_document",
            //         "action-myteam_probation_confirmation_requests",
            //         "update-myteam_leave_requests_status",
            //         "view-myteam_exit_requests_document",
            //         "tab-attendance_livetracker_export",
            //         "view-day_wise_attendance_details",
            //         "export-attendance_summary_list"
            //     ]
            // },
            // {
            //     "uuid": "6fa2f00b-5b50-4023-aedd-427ce763153a",
            //     "parent_id": "c4a8e192-b898-42b7-afa6-3d60df2a237f",
            //     "name": "Summary",
            //     "slug": "summary",
            //     "module_url": "/compensation/summary",
            //     "icon": "Summarize",
            //     "module_order": "1",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-mycompensation_summary"
            //     ]
            // },
            // {
            //     "uuid": "77c17760-e1c8-4282-bce9-6f2da83e254e",
            //     "parent_id": "0",
            //     "name": "Leave",
            //     "slug": "leave",
            //     "module_url": "/leave-tracker",
            //     "icon": "EventBusy",
            //     "module_order": "3",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "90ceb171-71a9-4afc-a47f-223250743573",
            //     "parent_id": "0",
            //     "name": "Notifications",
            //     "slug": "notifications",
            //     "module_url": "/notifications",
            //     "icon": "PunchClock",
            //     "module_order": "",
            //     "is_navigation": 0,
            //     "operations": []
            // },
            // {
            //     "uuid": "b3e716be-bf9b-4801-b1b2-b634b9579f26",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Onboards",
            //     "slug": "onboards",
            //     "module_url": "/recruitment/onboards",
            //     "icon": "VerifiedUser",
            //     "module_order": "5",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "bbc7e8f0-6b9e-470e-b724-437448a77e7c",
            //     "parent_id": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "name": "Jobs",
            //     "slug": "jobs",
            //     "module_url": "/recruitment/jobs",
            //     "icon": "WorkOutline",
            //     "module_order": "2",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-job_details",
            //         "view-job_list"
            //     ]
            // },
            // {
            //     "uuid": "c4a8e192-b898-42b7-afa6-3d60df2a237f",
            //     "parent_id": "0",
            //     "name": "My Compensation",
            //     "slug": "my-compensation",
            //     "module_url": "/compensation",
            //     "icon": "LocalAtm",
            //     "module_order": "4",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "e2a4c5a8-3c72-4c0e-9c46-e18dc99c5e5d",
            //     "parent_id": "20cae16b-71dc-4592-bd3c-f524c01bac1f",
            //     "name": "Ticket List",
            //     "slug": "ticket-list",
            //     "module_url": "/tickets/tickets-list",
            //     "icon": "SupportAgent",
            //     "module_order": "1",
            //     "is_navigation": 1,
            //     "operations": [
            //         "view-ticket_details",
            //         "create-ticket",
            //         "view-ticket_document",
            //         "view-ticket_list"
            //     ]
            // },
            // {
            //     "uuid": "e2b55403-8a09-4b5c-9f66-f07eb88763fb",
            //     "parent_id": "5cb04c36-6b11-470f-8344-beed355a8a4b",
            //     "name": "Settings UserProfile",
            //     "slug": "settings-userprofile",
            //     "module_url": "/settings/userprofile",
            //     "icon": "People",
            //     "module_order": "2",
            //     "is_navigation": 0,
            //     "operations": [
            //         "create-exit_request_interview",
            //         "delete-family_details",
            //         "create-family_details",
            //         "update-demat_details",
            //         "delete-demat_details",
            //         "create-demat_details",
            //         "update-insurance_details",
            //         "delete-insurance_details",
            //         "create-insurance_details",
            //         "create-exit_request",
            //         "view-exit_request_attachment",
            //         "update-family_details",
            //         "cancel-exit_request",
            //         "create-employee_confirmation",
            //         "view-userprofile",
            //         "tab-userprofile_assets",
            //         "create-emergency_contact_details",
            //         "tab-userprofile_profile",
            //         "tab-userprofile_financial",
            //         "tab-userprofile_organisation",
            //         "tab-userprofile_documents",
            //         "tab-userprofile_holidays",
            //         "tab-userprofile_salaryslip",
            //         "tab-userprofile_exit",
            //         "tab-userprofile_clientbranches",
            //         "update-primary_details",
            //         "upload-profile_picture",
            //         "update-emergency_contact_details",
            //         "delete-emergency_contact_details",
            //         "update-education_details",
            //         "create-education_details",
            //         "update-address_details",
            //         "delete-address_details",
            //         "create-address_details",
            //         "delete-work_experience",
            //         "update-work_experience",
            //         "create-work_experience"
            //     ]
            // },
            // {
            //     "uuid": "ea9cdd01-b187-433b-a6c6-d858c483c038",
            //     "parent_id": "0",
            //     "name": "Recruitment",
            //     "slug": "recruitment",
            //     "module_url": "/recruitment",
            //     "icon": "GroupAdd",
            //     "module_order": "1",
            //     "is_navigation": 1,
            //     "operations": []
            // },
            // {
            //     "uuid": "fd4971fb-3ba3-4ca5-9d65-f40c4488edb6",
            //     "parent_id": "0",
            //     "name": "Global Permissions",
            //     "slug": "global-permissions",
            //     "module_url": "/global-permissions",
            //     "icon": " ",
            //     "module_order": "",
            //     "is_navigation": 0,
            //     "operations": [
            //         "enable-nav_bar_notification_bell_icon",
            //         "enable-employee_satisfaction_survey_icon"
            //     ]
            // }
        ]
    }
}
export const responseDataPermissionUsingRole: any = {

    'iam_superAdmin':  {
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "hrms_users"
            },
            {
                "role_slug": "super-admin"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "546d3b83-9bf5-4966-9b30-160983445a57",
                "parent_id": "0",
                "name": "Recruitment",
                "slug": "recruitment",
                "module_url": "/recruitment",
                "icon": "GroupAdd",
                "module_order": "1",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "faefb894-9148-441f-96f0-d850bd0120a2",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Jobs",
                "slug": "jobs",
                "module_url": "/recruitment/jobs",
                "icon": "WorkOutline",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [
                    "create-job",
                    "update-job_status",
                    "view-job_details",
                    "view-job_list"
                ]
            },
            {
                "uuid": "001a8cbc-47ce-4ae5-a8f1-cb72df85b4e1",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Candidates",
                "slug": "candidates",
                "module_url": "/recruitment/candidates",
                "icon": "People",
                "module_order": "3",
                "is_navigation": 1,
                "operations": [
                    "create-candidate",
                    "view-candidate_list"
                ]
            },
            {
                "uuid": "5d735566-68ef-4d25-8723-406dd24fc169",
                "parent_id": "0",
                "name": "Dashboard",
                "slug": "dashboard",
                "module_url": "/dashboard",
                "icon": "GridView",
                "module_order": "1",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "parent_id": "0",
                "name": "Employee",
                "slug": "employee",
                "module_url": " ",
                "icon": "Badge",
                "module_order": "11",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "9b5034b7-b80f-46dc-b034-12d2af36bfe0",
                "parent_id": "0",
                "name": "My Team Zone",
                "slug": "my-team-zone",
                "module_url": "/myteamzone",
                "icon": "Groups",
                "module_order": "7",
                "is_navigation": 1,
                "operations": [
                    "action-myteam_exit_requests",
                    "view-myteam_exit_requests_document",
                    "update-myteam_leave_requests_status",
                    "action-myteam_probation_confirmation_requests",
                    "view-myteam_leave_requests_document",
                    "update-myteam_regularization_requests_status",
                    "create-myteam_pip",
                    "view-myteam_pip_details",
                    "export-myteam_leave_report",
                    "export-myteam_attendance_report",
                    "view-exit_request_approver_review",
                    "tab-overview",
                    "tab-attendance",
                    "tab-leave",
                    "tab-pip",
                    "tab-probation_confirmation_request",
                    "tab-exit_request",
                    "tab-attendance_summary",
                    "tab-attendance_livetracker",
                    "tab-attendance_regularize_request",
                    "tab-attendance_report",
                    "tab-leave_summary",
                    "tab-leave_employee_details",
                    "tab-leave_leave_request",
                    "tab-leave_report"
                ]
            },
            {
                "uuid": "6025d6ed-331d-4183-8ed8-8d9f77d254b8",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Departments",
                "slug": "departments",
                "module_url": "/masters/departments",
                "icon": "AccountBalance",
                "module_order": "1",
                "is_navigation": 1,
                "operations": [
                    "create-department",
                    "update-department"
                ]
            },
            {
                "uuid": "0b2e993c-f80b-4d92-8932-4f27a6479078",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Interviews",
                "slug": "interviews",
                "module_url": "/recruitment/interviews",
                "icon": "CalendarMonth",
                "module_order": "4",
                "is_navigation": 1,
                "operations": [
                    "update-candidate_stage",
                    "update-candidate_stage",
                    "update-offer",
                    "send-document_link",
                    "create-offer",
                    "send-offer",
                    "create-employee",
                    "create-employee_onboard"
                ]
            },
            {
                "uuid": "848987f9-caf5-482b-847c-8c9129498421",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Onboards",
                "slug": "onboards",
                "module_url": "/recruitment/onboards",
                "icon": "VerifiedUser",
                "module_order": "5",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "726d3546-36f0-4ac9-9e14-5d41907665b2",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Vendors",
                "slug": "vendors",
                "module_url": "/recruitment/vendors",
                "icon": "Store",
                "module_order": "6",
                "is_navigation": 1,
                "operations": [
                    "create-vendor"
                ]
            },
            {
                "uuid": "d6c6ede6-7d3a-4350-beaf-d98e2ca12342",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Referrals",
                "slug": "referrals",
                "module_url": "/recruitment/referrals",
                "icon": "PersonAddAlt1",
                "module_order": "7",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "6e5b5a19-6f1e-49f2-b477-9ea10e70a227",
                "parent_id": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "name": "Employee List",
                "slug": "employee-list",
                "module_url": "/employee/listing",
                "icon": "ListAlt",
                "module_order": "1",
                "is_navigation": 1,
                "operations": [
                    "view-employee_details_button",
                    "update-employee_status",
                    "tab-employee_list",
                    "tab-exit_requested_list",
                    "tab-exit_request_and_exited_list",
                    "tab-exited_list",
                    "create-employee"
                ]
            },
            {
                "uuid": "5df5f2bf-b37d-47c5-87ec-05421c4750b6",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Jobs Details",
                "slug": "jobs-details",
                "module_url": "/recruitment/jobs/details",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": [
                    "clone-job",
                    "edit-job",
                    "assign-vendor_add",
                    "publish-on_website_unpublish_from_website",
                    "create-candidate"
                ]
            },
            {
                "uuid": "6ea91d1a-b9ee-4e97-9748-8d253449dfa0",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Candidate Details",
                "slug": "candidate-details",
                "module_url": "/recruitment/candidates/details",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": [
                    "update-candidate_stage",
                    "update-candidate_stage",
                    "update-candidate_details",
                    "update-candidate_skills",
                    "update-candidate_additional_information",
                    "update-documents_status",
                    "upload-document",
                    "onboard-reject_hold_approve_action",
                    "update-onboard_details",
                    "send-pre_offer_document_link",
                    "update-ocr_data"
                ]
            },
            {
                "uuid": "36638b68-60f2-4d0b-ab20-4f00683be4f5",
                "parent_id": "0",
                "name": "People",
                "slug": "people",
                "module_url": "/employee-people",
                "icon": "People",
                "module_order": "10",
                "is_navigation": 1,
                "operations": [
                    "view-employee_details_button",
                    "view-employee_details_button",
                    "tab-organization_chart",
                    "tab-organization_chart",
                    "tab-organization_chart",
                    "tab-organization_directory",
                    "tab-organization_directory"
                ]
            },
            {
                "uuid": "7710d686-c3fe-4c8c-a649-1661b21a7c55",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Recruitment-Masters",
                "slug": "recruitment-masters",
                "module_url": "/masters/recruitment",
                "icon": "GroupAdd",
                "module_order": "5",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "deda8026-2e90-4b26-b73e-af12a6bbe2b4",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Attendance-Masters",
                "slug": "attendance-masters",
                "module_url": "/masters/attendance",
                "icon": "PunchClock",
                "module_order": "6",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "2300985a-0c08-4abd-80f9-86ffdae41e0b",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Leave-Masters",
                "slug": "leave-masters",
                "module_url": "/masters/leave",
                "icon": "EventBusy",
                "module_order": "8",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "0b80142d-d0d6-4bcf-aca9-5cb016f4818e",
                "parent_id": "0",
                "name": "My Compensation",
                "slug": "my-compensation",
                "module_url": "/compensation",
                "icon": "LocalAtm",
                "module_order": "4",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "844b9b6b-8863-4d66-b823-1b0fa13df8c2",
                "parent_id": "0b80142d-d0d6-4bcf-aca9-5cb016f4818e",
                "name": "Summary",
                "slug": "summary",
                "module_url": "/compensation/summary",
                "icon": "Summarize",
                "module_order": "1",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "043fef0e-57eb-4174-b948-91cf38896b0f",
                "parent_id": "0b80142d-d0d6-4bcf-aca9-5cb016f4818e",
                "name": "My Pay",
                "slug": "my-pay",
                "module_url": "/compensation/mypay",
                "icon": "Paid",
                "module_order": "1",
                "is_navigation": 1,
                "operations": [
                    "create-claim",
                    "create-claim",
                    "delete-claim"
                ]
            },
            {
                "uuid": "032139c7-9bbe-470d-adf5-6d30bfe3c3c9",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Compensation - Masters",
                "slug": "compensation---masters",
                "module_url": "/masters/compensation",
                "icon": "LocalAtm",
                "module_order": "7",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "48597ed5-cff5-445d-b503-ff1eeb5a4acc",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Salary",
                "slug": "salary",
                "module_url": "/admin/salary",
                "icon": "CurrencyRupee",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [
                    "generate-salary",
                    "upload-salary_earning_deduction",
                    "export-salary_processed_salaries",
                    "import-salary_processed_salaries",
                    "view-salary_slip",
                    "view-salary_breakoff",
                    "export-salary_hold_salaries",
                    "import-salary_hold_salaries",
                    "export-salary_hold_and_exit_salaries",
                    "import-salary_hold_and_exit_salaries",
                    "export-salary_verified_salaries",
                    "import-salary_verified_salaries",
                    "export-salary_disbursed_salaries",
                    "tab-generate_salary",
                    "tab-salary_overview",
                    "tab-earning_deduction",
                    "tab-processed_salary",
                    "tab-hold_salary",
                    "tab-hold_and_exit_salary",
                    "tab-verified_salary",
                    "tab-disbursed_salary",
                    "reprocess-salary",
                    "tab-fnf_salary",
                    "add-fnf-salary_processed_salaries"
                ]
            },
            {
                "uuid": "2519df8d-d68b-477a-afd6-69cf22c71457",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Policy - Master",
                "slug": "policy---master",
                "module_url": "/masters/policy",
                "icon": "Policy",
                "module_order": "9",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "parent_id": "0",
                "name": "All Masters",
                "slug": "all-masters",
                "module_url": " ",
                "icon": "Settings",
                "module_order": "12",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "d534924f-dcc0-4aec-96bd-a1636eefbe11",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Functional Role",
                "slug": "functional-role",
                "module_url": "/masters/functional-role",
                "icon": "ManageAccounts",
                "module_order": "3",
                "is_navigation": 1,
                "operations": [
                    "assign-functional_roles"
                ]
            },
            {
                "uuid": "41831e22-0bc2-4f3f-8b8a-49bde2019b1a",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "WorkFlow - Master",
                "slug": "workflow---master",
                "module_url": "/masters/workflow",
                "icon": "AccountTree",
                "module_order": "4",
                "is_navigation": 1,
                "operations": [
                    "create-workflow",
                    "update-workflow"
                ]
            },
            {
                "uuid": "d37ed145-77bb-48f5-9d2a-7b4be74ab05a",
                "parent_id": "0",
                "name": "Ticket",
                "slug": "ticket",
                "module_url": " ",
                "icon": "SupportAgent",
                "module_order": "8",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "cef824ad-03f7-414c-8d35-d0a1280aeb6d",
                "parent_id": "d37ed145-77bb-48f5-9d2a-7b4be74ab05a",
                "name": "Ticket List",
                "slug": "ticket-list",
                "module_url": "/tickets/tickets-list",
                "icon": "SupportAgent",
                "module_order": "1",
                "is_navigation": 1,
                "operations": [
                    "show-all_ticket_list",
                    "view-ticket_details",
                    "view-ticket_details",
                    "view-ticket_details",
                    "create-ticket",
                    "create-ticket",
                    "create-ticket",
                    "view-ticket_document"
                ]
            },
            {
                "uuid": "caac8832-9536-4417-91d9-44e581b5fcb7",
                "parent_id": "d37ed145-77bb-48f5-9d2a-7b4be74ab05a",
                "name": "Ticket Dashboard",
                "slug": "ticket-dashboard",
                "module_url": "/tickets/ticket-dashboard",
                "icon": "Leaderboard",
                "module_order": "1",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "parent_id": "0",
                "name": "Admin",
                "slug": "admin",
                "module_url": "/claim-management",
                "icon": "AdminPanelSettings",
                "module_order": "6",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "9d3ea864-e9a2-4d91-97e1-ccd82e706b83",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Claim Management",
                "slug": "claim-management",
                "module_url": "/admin/claim-management",
                "icon": "ManageAccounts",
                "module_order": "4",
                "is_navigation": 1,
                "operations": [
                    "test-claim_action",
                    "update-claim_management_status"
                ]
            },
            {
                "uuid": "27781588-98c3-472f-ade5-b5ac555a5676",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Register Reports",
                "slug": "register-reports",
                "module_url": "/admin/register-reports",
                "icon": "Assessment",
                "module_order": "2",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "1628f5e9-7e5c-4b3d-80b9-5066f0402891",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Designation",
                "slug": "designation",
                "module_url": "/masters/designations",
                "icon": "Badge",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [
                    "create-designation",
                    "update-designation"
                ]
            },
            {
                "uuid": "e72f16d4-c6a2-4d16-b495-309215021e09",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Exit Policy",
                "slug": "exit-policy",
                "module_url": "/masters/exit",
                "icon": "ExitToApp",
                "module_order": "5",
                "is_navigation": 1,
                "operations": [
                    "create-exit_policy",
                    "update-exit_policy",
                    "delete-exit_policy"
                ]
            },
            {
                "uuid": "04f1c9d7-87a6-4db3-be0d-48a76ce96b89",
                "parent_id": "0",
                "name": "Tax Management",
                "slug": "tax-management",
                "module_url": "/tax-management",
                "icon": "ReceiptLong",
                "module_order": "5",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "fc1399d8-8d83-4b4a-9772-8af71c47fa60",
                "parent_id": "04f1c9d7-87a6-4db3-be0d-48a76ce96b89",
                "name": "Self Tax Management",
                "slug": "self-tax-management",
                "module_url": "/tax-management/manage-tax",
                "icon": "ReceiptLong",
                "module_order": "1",
                "is_navigation": 1,
                "operations": [
                    "update-status",
                    "update-tax_declare_amount",
                    "update-tax_declare_amount",
                    "update-tax_declare_amount_status",
                    "upload-tax_declare_submission_proof",
                    "upload-tax_declare_submission_proof",
                    "download-tax_slip",
                    "download-tax_slip",
                    "view-tax_slip",
                    "view-tax_slip",
                    "view-tax_house_rent_file",
                    "view-tax_house_rent_file",
                    "update-tax_house_rent_status",
                    "update-tax_house_rent_status",
                    "update-tax_house_rent_detail",
                    "update-tax_house_rent_detail",
                    "view-tax_house_rent_detail",
                    "view-tax_house_rent_detail",
                    "view-self_tax_management_deductions"
                ]
            },
            {
                "uuid": "e86c26eb-6aac-4659-8cc1-560090a7dcae",
                "parent_id": "04f1c9d7-87a6-4db3-be0d-48a76ce96b89",
                "name": "Employee Tax Management",
                "slug": "employee-tax-management",
                "module_url": "/tax-management/employee-tax",
                "icon": "ReceiptLong",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [
                    "view-tax_cycle_employee_tax"
                ]
            },
            {
                "uuid": "1c11f90c-54e2-49cf-8458-c39baa94f774",
                "parent_id": "04f1c9d7-87a6-4db3-be0d-48a76ce96b89",
                "name": "Tax Cycle",
                "slug": "tax-cycle",
                "module_url": "/tax-management/company-tax-cycle",
                "icon": "ReceiptLong",
                "module_order": "3",
                "is_navigation": 1,
                "operations": [
                    "create-tax_cycle",
                    "update-tax_cycle"
                ]
            },
            {
                "uuid": "f0a6b0f3-f41e-4394-a538-74c1fc61898b",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Employee Satisfaction",
                "slug": "employee-satisfaction",
                "module_url": "/admin/employee-satisfaction",
                "icon": "ThumbsUpDown",
                "module_order": "6",
                "is_navigation": 1,
                "operations": [
                    "create-survey",
                    "edit-survey",
                    "delete-survey"
                ]
            },
            {
                "uuid": "aec18dd2-9d59-4e33-ad80-9523719ffbda",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Reports",
                "slug": "reports",
                "module_url": "/admin/admin-reports",
                "icon": "InsertChart",
                "module_order": "6",
                "is_navigation": 1,
                "operations": [
                    "export-report_attendance_regularizerequest",
                    "export-report_attendance_clockinout",
                    "export-report_leave_summary",
                    "export-report_leave_request",
                    "export-report_employee_confirmation",
                    "export-report_employee_pip",
                    "export-report_employee_exit"
                ]
            },
            {
                "uuid": "1f9bbb05-218a-4204-bdcc-8358a92be025",
                "parent_id": "d37ed145-77bb-48f5-9d2a-7b4be74ab05a",
                "name": "Ticket - details",
                "slug": "ticket---details",
                "module_url": "/tickets/tickets-list/details",
                "icon": "Leaderboard",
                "module_order": "1",
                "is_navigation": 0,
                "operations": [
                    "update-ticket_status",
                    "update-ticket_status",
                    "update-ticket_status",
                    "update-ticket_priority",
                    "update-ticket_priority",
                    "update-ticket_priority",
                    "assign-ticket",
                    "assign-ticket",
                    "create-ticket_notes_todo",
                    "create-ticket_notes_todo",
                    "create-ticket_notes_todo",
                    "create-ticket_update_notes_todo_status",
                    "create-ticket_update_notes_todo_status",
                    "create-ticket_update_notes_todo_status",
                    "create-ticket_attach_document",
                    "create-ticket_attach_document",
                    "create-ticket_attach_document",
                    "create-ticket_comment",
                    "create-ticket_comment",
                    "create-ticket_comment"
                ]
            },
            {
                "uuid": "391448b5-8fef-46cf-8820-b37c08915221",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Vendor - details",
                "slug": "vendor---details",
                "module_url": "/recruitment/vendors/details",
                "icon": "Store",
                "module_order": "6",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "bf33cc2b-a292-4c0e-9807-fc7ac3ef6945",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Referrals - details",
                "slug": "referrals---details",
                "module_url": "/recruitment/referrals/details",
                "icon": "PersonAddAlt1Outlined",
                "module_order": "7",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "4aa9aebb-8d32-4428-98df-64dd243422cb",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Document - Master",
                "slug": "document---master",
                "module_url": "/masters/recruitment/document",
                "icon": "Settings",
                "module_order": "10",
                "is_navigation": 0,
                "operations": [
                    "manage-document_master"
                ]
            },
            {
                "uuid": "2ce24de5-6cd8-4d41-bb2a-315dbb1f15ec",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Document-master-manage Masters",
                "slug": "document-master-manage-masters",
                "module_url": "/masters/recruitment/document-manage",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "a827691e-f316-4501-aecc-316201d829a9",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Holiday - Master",
                "slug": "holiday---master",
                "module_url": "/masters/attendance/holiday",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "manage-holiday_master"
                ]
            },
            {
                "uuid": "bb75a2e3-38f3-4c1a-bff9-662d6fed919d",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Holiday-Masters - Manage",
                "slug": "holiday-masters---manage",
                "module_url": "/masters/attendance/holiday-manage",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "5c1a2f3a-4315-43ec-ab78-95315e48a37d",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Attendance - Policy - Master",
                "slug": "attendance---policy---master",
                "module_url": "/masters/attendance/policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "create-attendance_policy",
                    "update-attendance_policy_regularize_policy",
                    "delete-attendance_policy_regularize_policy"
                ]
            },
            {
                "uuid": "af80105a-f155-4436-b5ae-d5f185ca1d76",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Weekoff - Master",
                "slug": "weekoff---master",
                "module_url": "/masters/attendance/weekoff-master",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "create-weekoff_master",
                    "update-weekoff_master"
                ]
            },
            {
                "uuid": "59fbd443-e8a5-489c-942c-5c790aeb7dd4",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Shift - Master",
                "slug": "shift---master",
                "module_url": "/masters/attendance/shift",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "manage-shift_master"
                ]
            },
            {
                "uuid": "30ad20d6-24f0-4433-8cdd-72486a71ab45",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Shift - Master- Manage",
                "slug": "shift---master--manage",
                "module_url": "/masters/attendance/shift-manage",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "aa3bd10f-f7a4-4be3-9669-f7025a18a003",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Attendance Cycle - Master",
                "slug": "attendance-cycle---master",
                "module_url": "/masters/attendance/attendance-cycle",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "create-attendance_cycle_config",
                    "update-attendance_cycle_config",
                    "delete-attendance_cycle_config"
                ]
            },
            {
                "uuid": "0ad7be5d-ca62-4121-9983-a6941f8e992e",
                "parent_id": "0",
                "name": "Employee - details",
                "slug": "employee---details",
                "module_url": "/employee/details",
                "icon": "People",
                "module_order": "11",
                "is_navigation": 0,
                "operations": [
                    "assign-policy",
                    "assign-holiday",
                    "assign-weekoff",
                    "tab-userprofile_profile",
                    "tab-userprofile_profile",
                    "tab-userprofile_financial",
                    "tab-userprofile_financial",
                    "tab-userprofile_organisation",
                    "tab-userprofile_organisation",
                    "tab-userprofile_documents",
                    "tab-userprofile_documents",
                    "tab-userprofile_holidays",
                    "tab-userprofile_holidays",
                    "tab-userprofile_weekoff",
                    "tab-userprofile_weekoff",
                    "tab-userprofile_policies",
                    "tab-userprofile_policies",
                    "tab-userprofile_salaryslip",
                    "tab-userprofile_clientbranches",
                    "tab-userprofile_clientbranches",
                    "update-primary_details",
                    "create-emergency_contact_details",
                    "update-emergency_contact_details",
                    "delete-emergency_contact_details",
                    "update-education_details",
                    "create-education_details",
                    "update-address_details",
                    "delete-address_details",
                    "create-address_details",
                    "delete-work_experience",
                    "update-work_experience",
                    "create-work_experience",
                    "update-family_details",
                    "delete-family_details",
                    "create-family_details",
                    "update-demat_details",
                    "delete-demat_details",
                    "create-demat_details",
                    "update-insurance_details",
                    "delete-insurance_details",
                    "create-insurance_details",
                    "create-client_branch_details",
                    "view-exit_request_attachment",
                    "upload-document_employee_section",
                    "tab-userprofile_accesscontrol",
                    "tab-userprofile_assets",
                    "allocate-asset_request"
                ]
            },
            {
                "uuid": "d1109bc0-66fa-4212-8e00-ee052b53408b",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Compesation Salary - Master",
                "slug": "compesation-salary---master",
                "module_url": "/masters/compensation/salary",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": [
                    "create-salary_component",
                    "update-salary_component_status"
                ]
            },
            {
                "uuid": "097073d0-61bd-4beb-b70b-e550c97661d1",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Compensation - Master - Salary-template",
                "slug": "compensation---master---salary-template",
                "module_url": "/masters/compensation/salary-template",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": [
                    "create-salary_template",
                    "view-salary_template",
                    "update-salary_template_status"
                ]
            },
            {
                "uuid": "2367036c-c88c-4110-a6df-66dd7b957898",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Leave Policy - Master",
                "slug": "leave-policy---master",
                "module_url": "/masters/leave/leave-policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "create-leave_policy",
                    "update-leave_policy"
                ]
            },
            {
                "uuid": "9f600142-c3b7-48f5-81c0-bcb11129bcf7",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Company - Policy - Master",
                "slug": "company---policy---master",
                "module_url": "/masters/policy/company-policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "create-company_policy",
                    "delete-company_policy",
                    "update-company_policy"
                ]
            },
            {
                "uuid": "2161b1f0-e2c5-4b33-9099-2ea4465be36f",
                "parent_id": "0",
                "name": "Settings",
                "slug": "settings",
                "module_url": " ",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "f82d99f3-efd6-443f-b671-6073ab81cbe9",
                "parent_id": "2161b1f0-e2c5-4b33-9099-2ea4465be36f",
                "name": "Settings UserProfile",
                "slug": "settings-userprofile",
                "module_url": "/settings/userprofile",
                "icon": "People",
                "module_order": "2",
                "is_navigation": 0,
                "operations": [
                    "upload-profile_picture",
                    "upload-profile_picture",
                    "tab-userprofile_profile",
                    "tab-userprofile_profile",
                    "tab-userprofile_financial",
                    "tab-userprofile_financial",
                    "tab-userprofile_organisation",
                    "tab-userprofile_organisation",
                    "tab-userprofile_documents",
                    "tab-userprofile_documents",
                    "tab-userprofile_holidays",
                    "tab-userprofile_holidays",
                    "tab-userprofile_weekoff",
                    "tab-userprofile_policies",
                    "tab-userprofile_salaryslip",
                    "tab-userprofile_salaryslip",
                    "tab-userprofile_exit",
                    "tab-userprofile_exit",
                    "tab-userprofile_clientbranches",
                    "tab-userprofile_clientbranches",
                    "update-primary_details",
                    "update-primary_details",
                    "create-emergency_contact_details",
                    "create-emergency_contact_details",
                    "update-emergency_contact_details",
                    "update-emergency_contact_details",
                    "delete-emergency_contact_details",
                    "delete-emergency_contact_details",
                    "update-education_details",
                    "update-education_details",
                    "create-education_details",
                    "create-education_details",
                    "update-address_details",
                    "update-address_details",
                    "delete-address_details",
                    "delete-address_details",
                    "create-address_details",
                    "create-address_details",
                    "delete-work_experience",
                    "delete-work_experience",
                    "update-work_experience",
                    "update-work_experience",
                    "create-work_experience",
                    "create-work_experience",
                    "update-family_details",
                    "update-family_details",
                    "delete-family_details",
                    "delete-family_details",
                    "create-family_details",
                    "create-family_details",
                    "update-demat_details",
                    "update-demat_details",
                    "delete-demat_details",
                    "delete-demat_details",
                    "create-demat_details",
                    "create-demat_details",
                    "update-insurance_details",
                    "update-insurance_details",
                    "delete-insurance_details",
                    "delete-insurance_details",
                    "create-insurance_details",
                    "create-insurance_details",
                    "create-client_branch_details",
                    "create-exit_request",
                    "create-exit_request",
                    "view-exit_request_attachment",
                    "view-exit_request_attachment",
                    "create-exit_request_interview",
                    "create-exit_request_interview",
                    "cancel-exit_request",
                    "cancel-exit_request",
                    "assign-policy",
                    "assign-holiday",
                    "assign-weekoff",
                    "tab-userprofile_accesscontrol",
                    "upload-document_employee_section",
                    "create-employee_confirmation",
                    "create-employee_confirmation",
                    "tab-userprofile_assets",
                    "tab-userprofile_assets"
                ]
            },
            {
                "uuid": "a0e46aa4-a535-4cbb-9cd9-91537a7669ac",
                "parent_id": "04f1c9d7-87a6-4db3-be0d-48a76ce96b89",
                "name": "Previous Employee",
                "slug": "previous-employee",
                "module_url": "/tax-management/previous-employee",
                "icon": "ReceiptLong",
                "module_order": "4",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "72271488-1229-4918-b61a-7bcb12e73138",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Loan Advance",
                "slug": "loan-advance",
                "module_url": "/admin/loan-advance",
                "icon": "CreditScore",
                "module_order": "5",
                "is_navigation": 1,
                "operations": [
                    "update_status",
                    "disbursed-status",
                    "settlement-status"
                ]
            },
            {
                "uuid": "55b74907-6324-490c-b4d6-c080f014eb66",
                "parent_id": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "name": "Employee Loan",
                "slug": "employee-loan",
                "module_url": "/employee/loan",
                "icon": "CreditScore",
                "module_order": "2",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "ee7caaa7-3432-4ba8-acde-ac8c74022a21",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Location",
                "slug": "location",
                "module_url": "/masters/branch-location",
                "icon": "Place",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [
                    "create-location_branch"
                ]
            },
            {
                "uuid": "5f83a1cc-7677-4ac3-9f16-7d1ea5e2d4ec",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Branch Vertical Mapping",
                "slug": "branch-vertical-mapping",
                "module_url": "/masters/branch-vertical-mapping",
                "icon": "Schema",
                "module_order": "3",
                "is_navigation": 1,
                "operations": [
                    "create-vertical_branch_mapping"
                ]
            },
            {
                "uuid": "ac039e79-2634-4836-bdc7-129fbaf56988",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Clients",
                "slug": "clients",
                "module_url": "/masters/clients",
                "icon": "Schema",
                "module_order": "3",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "94ce27a9-0476-4f6e-95e7-fedf9e82c7e4",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "Employee Satisfaction Analysis",
                "slug": "employee-satisfaction-analysis",
                "module_url": "/admin/employee-satisfaction-analysis",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "4c949eeb-99a0-4732-94ca-4621120962d7",
                "parent_id": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "name": "Profile Update Requests",
                "slug": "profile-update-requests",
                "module_url": "/employee/profile-update-requests",
                "icon": "AccountCircleIcon",
                "module_order": "3",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "0c06b1f5-e9e8-44cd-bde3-1671503e0248",
                "parent_id": "0",
                "name": "Notifications",
                "slug": "notifications",
                "module_url": "/notifications",
                "icon": "PunchClock",
                "module_order": "",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "eb335820-e8aa-454e-9653-364a68dc9292",
                "parent_id": "0",
                "name": "Attendance",
                "slug": "attendance",
                "module_url": "/attendance",
                "icon": "EventAvailable",
                "module_order": "2",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "71669705-bea0-478e-b0cf-72515f9d8d58",
                "parent_id": "0",
                "name": "Leave",
                "slug": "leave",
                "module_url": "/leave-tracker",
                "icon": "EventBusy",
                "module_order": "3",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "0dd2225f-576a-4e33-839b-fc9ca7d17d62",
                "parent_id": "0",
                "name": "Policy",
                "slug": "policy",
                "module_url": "/company-policy",
                "icon": "Policy",
                "module_order": "9",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "4c0dfc8a-5795-47f4-a927-c4cc00abbb23",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Notification",
                "slug": "notification",
                "module_url": "/notifications/masters",
                "icon": "NotificationsNone",
                "module_order": "3",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "4bd5a3e2-91ec-4298-a041-2efb1af214ba",
                "parent_id": "4c0dfc8a-5795-47f4-a927-c4cc00abbb23",
                "name": "Notification Master Details",
                "slug": "notification-master-details",
                "module_url": "/notifications/masters/notification-master",
                "icon": " ",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "fd65da72-3e27-4bae-a645-652b2288b841",
                "parent_id": "0",
                "name": "Global Permissions",
                "slug": "global-permissions",
                "module_url": "/global-permissions",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": [
                    "enable-nav_bar_notification_bell_icon",
                    "enable-nav_bar_notification_bell_icon",
                    "enable-employee_satisfaction_survey_icon",
                    "enable-employee_satisfaction_survey_icon"
                ]
            },
            {
                "uuid": "20d9b0e6-2f1b-4982-ba66-3f60e863675e",
                "parent_id": "0",
                "name": "Exit Dashboard",
                "slug": "exit-dashboard",
                "module_url": "/exit-dashboard",
                "icon": " ",
                "module_order": "0",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "24ffa306-908b-4079-bfe1-cb1adb037899",
                "parent_id": "7b4c04ed-5e7c-45eb-8467-73beb1da8068",
                "name": "FNF",
                "slug": "fnf",
                "module_url": "/admin/fnf",
                "icon": "Paid",
                "module_order": "7",
                "is_navigation": 1,
                "operations": [
                    "update-fnf_settlement_status",
                    "view-fnf_settlement_details",
                    "create-fnf_settlement_form",
                    "send-fnf_settlement_concent"
                ]
            },
            {
                "uuid": "5b20aa16-0e46-4c44-a94e-4c7f9f747af7",
                "parent_id": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "name": "Employee Payroll",
                "slug": "employee-payroll",
                "module_url": "/employee/payroll",
                "icon": "PaymentsIcon",
                "module_order": "",
                "is_navigation": 1,
                "operations": []
            },
            {
                "uuid": "389be9b6-89d4-46bd-b81c-e46975d642b4",
                "parent_id": "0",
                "name": "Employee Payroll Details",
                "slug": "employee-payroll-details",
                "module_url": "/employee/payroll-details",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": [
                    "tab-payroll_details_payroll",
                    "tab-payroll_details_organisation",
                    "create-employee_payroll"
                ]
            },
            {
                "uuid": "01f1f9e1-444f-40fe-9ba6-2544c717e25d",
                "parent_id": "cbd2d377-10a1-4c0b-94e7-6be0551e5fe2",
                "name": "Employee Assets",
                "slug": "employee-assets",
                "module_url": "/employee/assets",
                "icon": " ",
                "module_order": "",
                "is_navigation": 0,
                "operations": []
            }
        ]
    },



    //---------------------------------------------------------------------------------------------------------------------------//




    'vendor': {
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "vendor"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        user_role_permission: [
            {
                "uuid": "recruitment123",
                "parent_id": "0",
                "name": "Recruitment",
                "slug": "recruitment",
                "module_url": "/recruitment",
                "icon": "GroupAdd",
                "module_order": "2",
                "is_navigation": 1,
            },
            {
                "uuid": "Jobs123",
                "parent_id": "recruitment123",
                "name": "Jobs",
                "slug": "jobs",
                "module_url": "/recruitment/jobs",
                "icon": "WorkOutline",
                "module_order": "2",
                "is_navigation": 1,
                "operations": [

                ]
            },
            {
                "uuid": "Jobs123333",
                "parent_id": "recruitment123",
                "name": "Jobs Details",
                "slug": "jobs Details",
                "module_url": "/recruitment/jobs/details",
                "icon": "WorkOutline",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "391448b5-8fef-46cf-8820-b37c08915221",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Vendor - details",
                "slug": "vendor---details",
                "module_url": "/recruitment/vendors/details",
                "icon": "Store",
                "module_order": "6",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "bf33cc2b-a292-4c0e-9807-fc7ac3ef6945",
                "parent_id": "546d3b83-9bf5-4966-9b30-160983445a57",
                "name": "Referrals - details",
                "slug": "referrals---details",
                "module_url": "/recruitment/referrals/details",
                "icon": "PersonAddAlt1Outlined",
                "module_order": "7",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "4aa9aebb-8d32-4428-98df-64dd243422cb",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Document - Master",
                "slug": "document---master",
                "module_url": "/masters/recruitment/document",
                "icon": "Settings",
                "module_order": "10",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "2ce24de5-6cd8-4d41-bb2a-315dbb1f15ec",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Document-master-manage Masters",
                "slug": "document-master-manage-masters",
                "module_url": "/masters/recruitment/document-manage",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "a827691e-f316-4501-aecc-316201d829a9",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Holiday - Master",
                "slug": "holiday---master",
                "module_url": "/masters/attendance/holiday",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "bb75a2e3-38f3-4c1a-bff9-662d6fed919d",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Holiday-Masters - Manage",
                "slug": "holiday-masters---manage",
                "module_url": "/masters/attendance/holiday-manage",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "5c1a2f3a-4315-43ec-ab78-95315e48a37d",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Attendance - Policy - Master",
                "slug": "attendance---policy---master",
                "module_url": "/masters/attendance/policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "af80105a-f155-4436-b5ae-d5f185ca1d76",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Weekoff - Master",
                "slug": "weekoff---master",
                "module_url": "/masters/attendance/weekoff-master",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "59fbd443-e8a5-489c-942c-5c790aeb7dd4",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Shift - Master",
                "slug": "shift---master",
                "module_url": "/masters/attendance/shift",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "30ad20d6-24f0-4433-8cdd-72486a71ab45",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Shift - Master- Manage",
                "slug": "shift---master--manage",
                "module_url": "/masters/attendance/shift-manage",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "aa3bd10f-f7a4-4be3-9669-f7025a18a003",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Attendance Cycle - Master",
                "slug": "attendance-cycle---master",
                "module_url": "/masters/attendance/attendance-cycle",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "0ad7be5d-ca62-4121-9983-a6941f8e992e",
                "parent_id": "0",
                "name": "Employee - details",
                "slug": "employee---details",
                "module_url": "/employee/details",
                "icon": "People",
                "module_order": "3",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "d1109bc0-66fa-4212-8e00-ee052b53408b",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Compesation Salary - Master",
                "slug": "compesation-salary---master",
                "module_url": "/masters/compensation/salary",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "097073d0-61bd-4beb-b70b-e550c97661d1",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Compensation - Master - Salary-template",
                "slug": "compensation---master---salary-template",
                "module_url": "/masters/compensation/salary-template",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "2367036c-c88c-4110-a6df-66dd7b957898",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Leave Policy - Master",
                "slug": "leave-policy---master",
                "module_url": "/masters/leave/leave-policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "9f600142-c3b7-48f5-81c0-bcb11129bcf7",
                "parent_id": "f0a0ef20-5138-48ae-bbfc-29d1ddda49b8",
                "name": "Company - Policy - Master",
                "slug": "company---policy---master",
                "module_url": "/masters/policy/company-policy",
                "icon": "Settings",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "2161b1f0-e2c5-4b33-9099-2ea4465be36f",
                "parent_id": "0",
                "name": "Settings",
                "slug": "settings",
                "module_url": " ",
                "icon": "Settings",
                "module_order": "1",
                "is_navigation": 0,
                "operations": []
            },
            {
                "uuid": "f82d99f3-efd6-443f-b671-6073ab81cbe9",
                "parent_id": "2161b1f0-e2c5-4b33-9099-2ea4465be36f",
                "name": "Settings UserProfile",
                "slug": "settings-userprofile",
                "module_url": "/settings/userprofile",
                "icon": "People",
                "module_order": "2",
                "is_navigation": 0,
                "operations": []
            }
        ]
    }



}










